<div class="agent-group-info-container">
  <div class="agent-group-details">
    <div class="form-row">
      <label for="agentGroupName">{{'Agent Group Name' | translate}}:</label>
      <input id="agentGroupName" type="text" [value]="agentGroupDetails?.name || '-'" disabled />
    </div>
    <div class="form-row">
      <label for="code">{{'Code' | translate}}:</label>
      <input id="code" type="text" [value]="agentGroupDetails?.casId || '-'" disabled />
    </div>
    <div class="form-row">
      <label for="type">{{'Type' | translate}}:</label>
      <input id="type" type="text" [value]="agentGroupDetails?.type || '-'" disabled />
    </div>
    <div class="form-row">
      <label for="agents">{{'Associated Agents' | translate}}:</label>
      <input id="agents" type="text" [value]="dataSource?.data?.length || 0" disabled />
    </div>
  </div>
  <div class="action-buttons">
    <button class="btn" (click)="addAgentsToGroup(agentGroupDetails)">{{'Add Agents' | translate}}</button>
  </div>
</div>

<mat-tab-group [mat-stretch-tabs]="false" class="sidebar-tabs" (selectedTabChange)="onTabChange($event)">
  <mat-tab label="{{ 'Associated Agents' | translate }}">
    <div class="custom-theme-table mt-3">
      <div class="custom-scrollbar table-responsive outer-bordered-table">
        <table mat-table class="table table-striped" [dataSource]="dataSource" matSort matSortDisableClear>

          <tr class="mat-row" *matNoDataRow [ngClass]="{'loading-row':isLoading}">
            <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
              @if (isLoading) {
                <ng-container class="loader-container">
                  <app-rings-loader class="bg-transparent"></app-rings-loader>
                </ng-container>
              } @else {
                {{'No data matching the filter' | translate}}
              }
            </td>
          </tr>

          <ng-container matColumnDef="name">
            <th class="left-aligned" mat-header-cell *matHeaderCellDef mat-sort-header>{{'Agent Name' | translate}}</th>
            <td class="left-aligned" mat-cell *matCellDef="let element">{{ element.name ?? '-'}}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th class="text-center" mat-header-cell *matHeaderCellDef>{{'Actions' | translate}}</th>
            <td class="text-center" mat-cell *matCellDef="let element">
              <i class="delete-icon fa fa-trash" [title]="'Remove Agent from Group' | translate"
              (click)="openRemoveAgentDialog(element.id)"></i>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;" [class.even-row]="even"> </tr>
        </table>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="{{ 'Organization Level' | translate }}">
    <div class="custom-theme-table mt-3">
      <div class="custom-scrollbar table-responsive outer-bordered-table">
        <table mat-table class="table table-striped" [dataSource]="orgLevelDataSource">

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center" [attr.colspan]="displayedAssociatedColumns.length">
              {{'No associated organization levels' | translate}}
            </td>
          </tr>

          <ng-container matColumnDef="organizationLevelName">
            <th class="left-aligned" mat-header-cell *matHeaderCellDef>{{'Organization Level Name' | translate}}</th>
            <td class="left-aligned" mat-cell *matCellDef="let element">{{ element.organizationLevelName ?? '-' }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedAssociatedColumns"></tr>
          <tr mat-row *matRowDef="let row; let even = even; columns: displayedAssociatedColumns;" [class.even-row]="even"> </tr>
        </table>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="{{ 'Agent Group History' | translate }}">
    <div class="custom-theme-table mt-3">
      <div class="custom-scrollbar table-responsive outer-bordered-table">
        <table mat-table class="table table-striped" [dataSource]="historyDataSource">
          <tr class="mat-row" *matNoDataRow [ngClass]="{ 'loading-row': isHistoryLoading }">
            <td class="mat-cell text-center" [attr.colspan]="historyDisplayedColumns.length">
              @if (isHistoryLoading) {
                <app-rings-loader class="bg-transparent"></app-rings-loader>
              } @else {
                {{ 'No data matching the filter' | translate }}
              }
            </td>
          </tr>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>{{ 'Name' | translate }}</th>
            <td mat-cell *matCellDef="let history" [ngClass]="{ 'highlight': $safeNavigationMigration(history.changedFieldSet?.has('Name')) }"><span>{{ history?.name || '-' }}</span></td>
          </ng-container>

          <ng-container matColumnDef="casId">
            <th mat-header-cell *matHeaderCellDef>{{ 'Code' | translate }}</th>
            <td mat-cell *matCellDef="let history" [ngClass]="{ 'highlight': $safeNavigationMigration(history.changedFieldSet?.has('CasId')) }"><span>{{ history?.casId || '-' }}</span></td>
          </ng-container>

          <ng-container matColumnDef="organizationLevelName">
            <th mat-header-cell *matHeaderCellDef>{{ 'Visibility' | translate }}</th>
            <td mat-cell *matCellDef="let history" [ngClass]="{ 'highlight': history.changedFieldSet?.has('OrganizationLevelName') || history.changedFieldSet?.has('OrganizationLevelId') }"><span>{{ history?.organizationLevelName || '-' }}</span></td>
          </ng-container>

          <ng-container matColumnDef="dateUpdated">
            <th mat-header-cell *matHeaderCellDef>{{ 'Updated Date' | translate }}</th>
            <td mat-cell *matCellDef="let history" [ngClass]="{ 'highlight': $safeNavigationMigration(history.changedFieldSet?.has('DateUpdated')) }"><span>{{ history.dateUpdatedDisplay }}</span></td>
          </ng-container>

          <ng-container matColumnDef="updatedByUserName">
            <th mat-header-cell *matHeaderCellDef>{{ 'Updated By' | translate }}</th>
            <td mat-cell *matCellDef="let history" [ngClass]="{ 'highlight': history.changedFieldSet?.has('UpdatedByUserName') || history.changedFieldSet?.has('UpdatedByUserId') }"><span>{{ history?.updatedByUserName || '-' }}</span></td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="historyDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: historyDisplayedColumns"></tr>
        </table>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
